import StageContainer from "./StageContainer";
import StageStore from "./StageStore"

export default StageStore(StageContainer);
